import React, {
  useEffect,
  useState,
} from "react";
import {
  Navigate,
  useLocation,
} from "react-router-dom";
import {
  onAuthStateChanged,
} from "firebase/auth";
import { auth } from "../firebase";

export default function RequireAuth({
  children,
}) {
  const location =
    useLocation();

  const [
    authStatus,
    setAuthStatus,
  ] =
    useState("checking");

  useEffect(() => {
    let mounted = true;

    const unsubscribe =
      onAuthStateChanged(
        auth,
        (user) => {
          if (!mounted) return;

          const email =
            String(
              user?.email || ""
            )
              .trim()
              .toLowerCase();

          const validAdmin =
            Boolean(user) &&
            !email.endsWith(
              "@portal.gofoton.com"
            );

          setAuthStatus(
            validAdmin
              ? "authenticated"
              : "unauthenticated"
          );
        },
        (error) => {
          console.error(
            "Admin authentication check failed:",
            error
          );

          if (mounted) {
            setAuthStatus(
              "unauthenticated"
            );
          }
        }
      );

    const timeout =
      window.setTimeout(
        () => {
          if (
          mounted &&
          !auth.currentUser
        ) {
            setAuthStatus(
              "unauthenticated"
            );
          }
        },
        8000
      );

    return () => {
      mounted = false;
      window.clearTimeout(
        timeout
      );
      unsubscribe();
    };
  }, []);

  if (
    authStatus ===
    "checking"
  ) {
    return (
      <div
        style={{
          minHeight: "55vh",
          display: "grid",
          placeItems: "center",
          background: "#fff",
        }}
      >
        <div
          style={{
            padding: "18px 22px",
            border: "1px solid #e5e7eb",
            borderRadius: 14,
            color: "#6b7280",
            fontSize: 13,
            fontWeight: 700,
            background: "#fff",
          }}
        >
          Checking administrator sign-in...
        </div>
      </div>
    );
  }

  if (
    authStatus !==
    "authenticated"
  ) {
    return (
      <Navigate
        to="/login?mode=admin"
        replace
        state={{
          from:
            `${location.pathname}${location.search}`,
        }}
      />
    );
  }

  return children;
}